import React, { useState, useEffect } from 'react';

const PackageContext = React.createContext();

const initialPackage = null;
const packageList = [];

export const PackageProvider = ({ children }) => {
  const [selectedPackage, setSelectedPackage] = useState(initialPackage);
  const [packages, setPackages] = useState(packageList);
  const [ccToken, setCCToken] = useState("");
  const [triggerClick, setTriggerClick] = useState(false);

  const [threeDSessionId, setThreeDSessionId] = useState("");

  const [callBackUrl, setCallBackUrl] = useState("");
  const [discountList, setDiscountList] = useState([]);

  

  return (
    <PackageContext.Provider
      value={{
        selectedPackage,
        setSelectedPackage,
        packages,
        setPackages,
        ccToken,
        setCCToken,
        threeDSessionId,
        setThreeDSessionId,
        triggerClick,
        setTriggerClick,
        callBackUrl,
        setCallBackUrl,
        discountList,
        setDiscountList
      }}
    >
      {children}
    </PackageContext.Provider>
  );
};

export const usePackage = () => React.useContext(PackageContext);
